export const useCombineLoading = (loadings: boolean[]): boolean => {
  return loadings.some((query) => !!query);
};
